import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagService } from '../../services';
import { FeatureFlagsEnum } from '../../enums';
import { LDFlagValue } from 'launchdarkly-js-sdk-common';

@Pipe({
    name: 'isFeatureFlagEnabled',
    standalone: false
})
export class IsFeatureFlagEnabledPipe implements PipeTransform {
    constructor(private readonly featureFlagService: FeatureFlagService) {
    }
    transform(key: FeatureFlagsEnum, defaultValue?: LDFlagValue): Observable<boolean> {
        return this.featureFlagService.getFlag(key, defaultValue);
    }
}
